import Table from 'common/table/table';
import { ThemeHeader } from 'common/table/table-helper';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { SapId } from 'ui';

const ErrorText = styled.span`
  color: ${p => p.theme.colors.alerts[1]}
`;

const WarningText = styled.span`
  color: ${p => p.theme.colors.alerts[2]}
`;

const Wrapper = styled.div`
  background-color: #fff;
`;

const ContractsTable = ({ isLoading, contracts, intl }) => {
  const getColumns = () => {
    const { formatMessage: translate, formatDate } = intl;

    return [
      {
        displayName: translate({ id: 'dashboard.contractsTable.NUMBER_COL' }),
        renderFn: row => <SapId originalId={row.number}>{id => <>{id}</>}</SapId>,
        width: '150px',
      },
      {
        displayName: translate({ id: 'dashboard.contractsTable.LINE_NUMBER_COL' }),
        fieldName: 'lineNumber',
        width: '150px',
      },
      {
        displayName: translate({ id: 'dashboard.contractsTable.DESCRIPTION_COL' }),
        fieldName: 'name',
        tooltip: row => row.name,
        width: '450px',
      },
      {
        displayName: translate({ id: 'dashboard.contractsTable.TYPE_DESCRIPTION_COL' }),
        fieldName: 'typeDescription',
        width: '320px',
      },
      {
        displayName: translate({ id: 'dashboard.contractsTable.IS_ACTIVE_COL' }),
        fieldName: 'isActive',
        width: '120px',
      },
      {
        displayName: translate({ id: 'dashboard.contractsTable.START_DATE_COL' }),
        renderFn: v => v?.startDate && formatDate(v?.startDate),
        width: '120px',
      },
      {
        displayName: translate({ id: 'dashboard.contractsTable.END_DATE_COL' }),
        renderFn: v => v?.endDate && formatDate(v?.endDate),
        width: '120px',
      },
      {
        displayName: translate({ id: 'dashboard.contractsTable.EXPIRY_DATE_COL' }),
        renderFn: (v) => {
          const value = v.poExpiry;
          if (value?.expiryDate) {
            if (value.poExpiryBlock) {
              return <ErrorText>{formatDate(value.expiryDate)}</ErrorText>;
            } else if (value.poExpiryWarning) {
              return <WarningText>{formatDate(value.expiryDate)}</WarningText>;
            }
            return formatDate(value.expiryDate);
          }
          return null;
        },
        width: '120px',
      },
    ];
  };

  const renderHeader = () => <ThemeHeader inlineTable={true} height='50px'>
    <span>
      {`${intl.formatMessage({ id: 'dashboard.contractsTable.TABLE_TITLE' })} `}
      ({contracts?.length})
    </span>
  </ThemeHeader>;

  return (
    <Wrapper data-test-id='contracts'>
      <Table
        renderCustomHeader={renderHeader}
        columns={getColumns()}
        data={contracts}
        isLoading={isLoading}
        fullWidth={true}
        lightHeader={true}
        usePaging={true}
      />
    </Wrapper>
  );
};

ContractsTable.propTypes = {
  isLoading: PropTypes.bool,
  contracts: PropTypes.array,
  intl: PropTypes.object,
};

export default injectIntl(ContractsTable);
